module.exports = "<div *ngIf=\"visible\">\r\n  <div class=\"p-20 b-b\">\r\n    <h5 class=\"box-title\">\r\n      <i class=\"fa fa-exclamation-triangle mr-2\"></i>\r\n      <span>{{ message }}</span>\r\n    </h5>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/empty-list/empty-list.component.html
// module id = ./src/app/components/empty-list/empty-list.component.html
// module chunks = main